import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable, connectFunctionsEmulator } from "firebase/functions";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyABykn_sgUN5RHGhfUIR73qXZoD64MuASk",
  authDomain: "missingmatcher.firebaseapp.com",
  projectId: "missingmatcher",
  storageBucket: "missingmatcher.firebasestorage.app",
  messagingSenderId: "871419521823",
  appId: "1:871419521823:web:71feb77a6306a19e7c9e2a",
  measurementId: "G-7HK7K8DBBM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Connect to Firebase Functions emulator in development
// Only Functions will use local emulator, all other services use production
const useFunctionsEmulator = process.env.REACT_APP_USE_FUNCTIONS_EMULATOR !== 'false' &&
                             process.env.NODE_ENV === 'development';

if (useFunctionsEmulator) {
  // Only connect Functions to local emulator
  connectFunctionsEmulator(functions, 'localhost', 5004);
  console.log('🔧 Connected to local Functions emulator (Auth, Firestore, and Storage using production)');
}

// Cloud Functions - Using the new callable function
export const exportItems = async (hotelId, type = 'found') => {
  try {
    console.log('Calling Firebase Callable Function with hotelId:', hotelId, 'type:', type);
    
    // Get the current user to ensure authentication
    const user = auth.currentUser;
    if (!user) {
      throw new Error('User not authenticated');
    }
    
    // Create the callable function reference
    const exportItemsFunction = httpsCallable(functions, 'exportItems');
    
    // Call the function with data
    const result = await exportItemsFunction({ hotelId, type });
    
    console.log('Firebase Callable Function response:', result.data);
    
    if (!result.data || !result.data.csv) {
      console.log('No CSV data returned from function');
      return null;
    }
    
    return result.data.csv;
  } catch (error) {
    console.error('Firebase Callable Function call failed:', error);
    
    // Handle Firebase function errors more gracefully
    if (error.code) {
      switch (error.code) {
        case 'functions/unauthenticated':
          throw new Error('You must be logged in to export data');
        case 'functions/permission-denied':
          throw new Error('You do not have permission to export data for this hotel');
        case 'functions/invalid-argument':
          throw new Error('Invalid parameters provided');
        default:
          throw new Error(`Export failed: ${error.message}`);
      }
    }
    
    throw error;
  }
};

// Backward compatibility
export const exportFoundItemsCsv = (hotelId) => exportItems(hotelId, 'found');

// Cloud Functions - Callable functions
export const updateUserDisplayName = httpsCallable(functions, 'updateUserDisplayName');
export const notifyMatchConfirmed = httpsCallable(functions, 'notifyMatchConfirmed');
export const createPaymentIntent = httpsCallable(functions, 'createPaymentIntent');
export const finalizePayment = httpsCallable(functions, 'finalizePayment');
export const estimateShippingCost = httpsCallable(functions, 'estimateShippingCost');
export const setMatchConfirmation = httpsCallable(functions, 'setMatchConfirmation');
export const createDirectReturnFromFoundItem = httpsCallable(functions, 'createDirectReturnFromFoundItem');
export const shipMatchWithSagawa = httpsCallable(functions, 'shipMatchWithSagawa');
export const getSagawaUsage = httpsCallable(functions, 'getSagawaUsage');
export const getTrackingInfo = httpsCallable(functions, 'getTrackingInfo');

export default app; 
